import React from "react";

const inputBase = "w-full bg-nearblack border border-steel px-5 py-4 text-offwhite placeholder:text-mutedgray/50 font-sans focus:outline-none focus:border-strike transition-colors";

export function Field({ label, name, type = "text", value, onChange, required, placeholder, testId, half }) {
  return (
    <div className={half ? "" : "md:col-span-2"}>
      <label htmlFor={name} className="block tech-label text-mutedgray mb-3">
        {label}{required && <span className="text-strike"> *</span>}
      </label>
      <input
        id={name} name={name} type={type} value={value} onChange={onChange}
        required={required} placeholder={placeholder} className={inputBase}
        data-testid={testId}
      />
    </div>
  );
}

export function TextArea({ label, name, value, onChange, required, placeholder, rows = 4, testId }) {
  return (
    <div className="md:col-span-2">
      <label htmlFor={name} className="block tech-label text-mutedgray mb-3">
        {label}{required && <span className="text-strike"> *</span>}
      </label>
      <textarea
        id={name} name={name} value={value} onChange={onChange} rows={rows}
        required={required} placeholder={placeholder} className={inputBase + " resize-none"}
        data-testid={testId}
      />
    </div>
  );
}

export function SelectField({ label, name, value, onChange, options, required, testId, half }) {
  return (
    <div className={half ? "" : "md:col-span-2"}>
      <label htmlFor={name} className="block tech-label text-mutedgray mb-3">
        {label}{required && <span className="text-strike"> *</span>}
      </label>
      <select
        id={name} name={name} value={value} onChange={onChange} required={required}
        className={inputBase + " appearance-none cursor-pointer"} data-testid={testId}
      >
        <option value="">Select…</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}
